import React from 'react';
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import DoneIcon from '@mui/icons-material/Done';
import BottomSheet from './BottomSheet';

/**
 * Bottom sheet that picks one of `items` (`{ key, label, Icon? }`); `onChange` receives the
 * tapped item, then the sheet closes.
 */
const ReportListSheet = function ReportListSheet({
  open = false,
  onClose = () => {},
  title = '',
  items = [],
  value = null,
  onChange = () => {},
}) {
  const theme = useTheme();

  return (
    <BottomSheet open={open} onClose={onClose} title={title}>
      <List
        className="scr"
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          mb: 'calc(env(safe-area-inset-bottom) + 12px)',
        }}
      >
        {items.map((item) => {
          const selected = item.key === value;
          const { Icon } = item;
          return (
            <ListItemButton
              key={item.key}
              selected={selected}
              onClick={() => {
                onChange(item);
                onClose();
              }}
            >
              {Icon ? (
                <ListItemIcon
                  sx={{
                    color: selected
                      ? 'primary.main'
                      : theme.custom.mobile.mutedColor,
                  }}
                >
                  <Icon />
                </ListItemIcon>
              ) : null}
              <ListItemText primary={item.label} />
              {selected ? (
                <DoneIcon sx={{ color: 'primary.main', fontSize: 20 }} />
              ) : null}
            </ListItemButton>
          );
        })}
      </List>
    </BottomSheet>
  );
};

export default ReportListSheet;
